import { lazy } from "react";
import { ElementDetails } from "@/lib/types";
import { AgendaProps } from "./types";

export const details = {
  name: "Agenda",
  description: "View calendar events in a list",
  tags: ["Organization", "Productivity"],
  category: "Widget",
  grid: {
    "3x3": [3, 3],
    "4x3": [4, 3],
    "4x4": [4, 4],
  },
  gridNames: {
    "3x3": "3x3",
    "4x3": "4x3",
    "4x4": "4x4",
  },
  app: lazy(() => import("./App").then(m => ({ default: m.App }))),
  context: lazy(() => import("./Context").then(m => ({ default: m.Context }))),
  integrationsUsed: ["google"],
  integrationScopes: { google: ["calendar"] },
  defaultProps: {
    dateStyle: "large",
    calendarIds: ["primary"],
  },
} as ElementDetails<AgendaProps>;
